// extracted by mini-css-extract-plugin
export default {"taskContainer":"ToDoListView_taskContainer__X1JKN"};